import { action, observable } from "mobx";

import { INotifier } from "../../entryes/panel/Filestorage/types";
import { locale } from "moment";

export type MessageType = "success" | "error" | "info" | "warning";

const tl: any = (window as any).$.translator.translate.bind(
    (window as any).$.translator
  ),
  locales: any = {
    file_not_added: tl("Файл не добавлен"),
    files_not_added: tl("Файлы не добавлены"),
    ok_add: tl("Успешное добавление"),
    ok_delete: tl("Успешное удаление"),
    file_added: tl("Файл добавлен в урок"),
    files_added: tl("Файлы добавлены в урок"),
  };

export default class FSNotifierStore {
  rootStore: any;

  constructor(RootStore: any) {
    this.rootStore = RootStore;
  }

  @observable
  noteList: Array<INotifier> = [];

  @action
  enqueueSnackbar(note: { message: string; options: any }) {
    this.noteList.push({
      key: new Date().getTime() + Math.random(),
      ...note,
    });
  }

  @action
  removeSnackbar(note: INotifier) {
    var index = this.noteList.indexOf(note);
    if (index !== -1) this.noteList.splice(index, 1);
  }

  setSuccessfullyAddedNote = () => {
    this.enqueueSnackbar({
      message: locales.ok_add,
      options: {
        variant: "success",
      },
    });
  };

  setNoteOnUpload = (checkedFilesCount: number) => {
    this.enqueueSnackbar(
      checkedFilesCount > 1
        ? {
            message: locales.files_not_added,
            options: { variant: "error" },
          }
        : {
            message: locales.file_not_added,
            options: { variant: "error" },
          }
    );
  };

  setSuccessNote = (messageType: string) => {
    this.enqueueSnackbar({
      message: locales[messageType],
      options: {
        variant: "success",
      },
    });
  };

  addNotice = (message: string, messageType: MessageType) => {
    this.enqueueSnackbar({
      message: message,
      options: {
        variant: messageType,
      },
    });
  };
}

export { FSNotifierStore };
